import React, { useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./PatientTable.css";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "react-i18next";

const PatientTable = ({ patients, columns, loading, onRowClicked }) => {
    const gridRef = useRef(null);
    const { t } = useTranslation();

    const table_columns = columns.map(col => {
        return col.headerName !== t('seeMore') && col.headerName !== t('sendMessage')
            ? { ...col, filter: true, floatingFilter: true }
            : col;
    });

    useEffect(() => {
        if (gridRef.current && gridRef.current.api) {
            gridRef.current.api.sizeColumnsToFit();
        }
    }, [gridRef]);

    const onFirstDataRendered = (params) => {
        params.api.sizeColumnsToFit();
    };

    const defaultColDef = {
        flex: 1,
    };

    const pagination = true;
    const paginationPageSize = 10;
    const paginationPageSizeSelector = [10];

    return (
        <div className={"ag-theme-alpine"} style={{ padding: '20px' }}>
            {!loading && (
                <AgGridReact
                    ref={gridRef}
                    rowData={patients}
                    columnDefs={table_columns}
                    onFirstDataRendered={onFirstDataRendered}
                    defaultColDef={defaultColDef}
                    domLayout='autoHeight'
                    pagination={pagination}
                    paginationPageSize={paginationPageSize}
                    paginationPageSizeSelector={paginationPageSizeSelector}
                    onRowClicked={onRowClicked}  // Add the row click handler here
                />
            )}
            {loading && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                        backgroundColor: "white",
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <ClipLoader
                        color="#204770"
                        loading={loading}
                        size={100}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}
        </div>
    );
};

PatientTable.propTypes = {
    patients: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    onRowClicked: PropTypes.func.isRequired,  // Add PropTypes for onRowClicked
};

export default PatientTable;
